import React, { useState, useEffect } from "react";
import { Button, Spin, message, Input, Form, Select } from "antd";
import { updateException, createUser } from "../api";
import { ExceptionStatus } from "../ExceptionDrawer";
import Hide from "../../components/Hide";
import { useAuth } from "../../../auth/AuthContext";
import API from "../../../API";
import CouncilsAPI from "../../../API/councils";

const UserComponent = ({ exception, onClose, onResolved }) => {
    const [loading, setLoading] = useState(false);
    const [roles, setRoles] = useState([]);
    const [permissions, setPermissions] = useState([]);
    const [showProjectDropdown, setShowProjectDropdown] = useState(false);
    const [showProcuringEntityDropdown, setShowProcuringEntityDropdown] = useState(false);
    const [projects, setProjects] = useState([]);
    const [procuringEntities, setProcuringEntities] = useState([]);
    const [form] = Form.useForm();
    const { permissions: userPermissions } = useAuth();

    const canCreateUser = userPermissions.includes('can create user') || 
                         userPermissions.includes('can create pct user') || 
                         userPermissions.includes('can create pit user');

    useEffect(() => {
        const fetchRoles = async () => {
            try {
                const response = await API.get("roles");
                let availableRoles = response.data;
                
                if (userPermissions.includes('can create user')) {
                    availableRoles = response.data;
                } else if (userPermissions.includes('can create pct user')) {
                    availableRoles = response.data.filter(role => role.name !== 'admin');
                } else if (userPermissions.includes('can create pit user')) {
                    availableRoles = response.data.filter(role => 
                        ['pit', 'pit-focal-person'].includes(role.name)
                    );
                } else {
                    availableRoles = [];
                }
                
                setRoles(availableRoles);
            } catch (error) {
                console.error("Failed to fetch roles", error);
            }
        };
        fetchRoles();
    }, [userPermissions]);

    const handleRoleChange = (selectedRoles) => {
        console.log('handleRoleChange called with:', selectedRoles);
        
        if (!selectedRoles || selectedRoles.length === 0) {
            console.log('No roles selected, hiding dropdowns');
            setShowProjectDropdown(false);
            setShowProcuringEntityDropdown(false);
            return;
        }

        const selectedRoleObjects = roles.filter(role => selectedRoles.includes(role.name));
        const allPermissions = selectedRoleObjects.flatMap(role => role.permissions || []);
        const permissionNames = allPermissions.map(permission => permission.name);


        const hasPitRole = selectedRoles.some(role => ['pit', 'pit-focal-person'].includes(role));
        
        const canReadProject = permissionNames.includes("can read project");
        const showProject = canReadProject || hasPitRole;
        console.log('Can read project:', canReadProject);
        console.log('Show project dropdown:', showProject);
        setShowProjectDropdown(showProject);

        const canReadProcuringEntity = permissionNames.includes("can read procuring-entity");
        const showCouncil = hasPitRole;
        console.log('Can read procuring entity:', canReadProcuringEntity);
        console.log('Show council dropdown:', showCouncil);
        setShowProcuringEntityDropdown(showCouncil);
    };

    useEffect(() => {
        const fetchProjects = async () => {
            try {
                console.log('Fetching projects...');
                const response = await API.get("projects");
                console.log('Projects fetched:', response.data);
                setProjects(response.data);
            } catch (error) {
                console.error("Failed to fetch projects", error);
            }
        };

        const fetchProcuringEntities = async () => {
            try {
                // Don't fetch all councils initially - wait for project selection
                setProcuringEntities([]);
            } catch (error) {
                console.error("Failed to fetch procuring entities", error);
            }
        };

        fetchProjects();
        fetchProcuringEntities();
    }, []);

    const handleProjectChange = async (projectId) => {
        console.log('handleProjectChange called with:', projectId);
        
        if (projectId && (Array.isArray(projectId) ? projectId.length > 0 : true)) {
            try {
                console.log('Fetching councils for project(s):', projectId);
                // Fetch councils for the selected project(s)
                const projectIds = Array.isArray(projectId) ? projectId : [projectId];
                const allCouncils = [];
                
                for (const id of projectIds) {
                    console.log('Calling API for project ID:', id);
                    const response = await CouncilsAPI.getProjectCouncils(id);
                    console.log('API response:', response);
                    
                    if (response.success && response.data && response.data.data) {
                        allCouncils.push(...response.data.data);
                    }
                }
                
                console.log('All councils fetched:', allCouncils);
                
                const uniqueCouncils = allCouncils.filter((council, index, self) => 
                    index === self.findIndex(c => c.id === council.id)
                );
                
                console.log('Unique councils:', uniqueCouncils);
                setProcuringEntities(uniqueCouncils);
            } catch (error) {
                console.error("Failed to fetch councils for project", error);
                setProcuringEntities([]);
            }
        } else {
            console.log('No project selected, clearing councils');
            setProcuringEntities([]);
        }
    };

    useEffect(() => {
        if (exception?.unknown_infomation) {
            try {
                form.setFieldsValue({
                    first_name: '',
                    title: '',
                    last_name: '',
                    middle_name: '',
                    phone: '',
                    email: exception?.unknown_infomation || ''
                });
            } catch (error) {
                form.setFieldsValue({
                    first_name: '',
                    title: '',
                    last_name: '',
                    middle_name: '',
                    phone: '',
                    email: ''
                });
            }
        }
    }, [exception, form]);

    const handleCreateUser = async () => {
        try {
            const values = await form.validateFields();
            setLoading(true);
            
            if (exception.status === 'pending') {
                const payload = {
                    first_name: values.first_name,
                    title: values.title,
                    last_name: values.last_name,
                    middle_name: values.middle_name,
                    phone: values.phone,
                    email: values.email,
                    roles: values.roles || [],
                    project: values.project,
                    projectIds: values.project || [],
                    councilIds: values.council_id || [],
                    council_id: values.council_id || null,
                };
                
                debugger;
                
                await createUser(payload);
                await updateException(exception.id);
                message.success('User created successfully and invitation email sent!');
                try { if (typeof onResolved === 'function') await onResolved(); } catch {}
                onClose();
            } else {
                console.warn("Exception already resolved.");
                try { if (typeof onResolved === 'function') await onResolved(); } catch {}
                onClose();
            }
        } catch (error) {
            if (error.errorFields) {
                message.error('Please fill in all required fields');
            } else {
                const errorMessage = error.response?.data?.message || 'Failed to create user';
                message.error(errorMessage);
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{ marginTop: 20 }}>
            <Hide condition={exception.status === ExceptionStatus.RESOLVED}>
                <Spin spinning={loading} tip="Processing...">
                    <Form form={form} layout="vertical" style={{ marginBottom: 20 }}>
                        <Form.Item
                            label="First Name"
                            name="first_name"
                            rules={[{ required: true, message: 'Please enter first name' }]}
                        >
                            <Input placeholder="Enter first name" />
                        </Form.Item>
                        
                        <Form.Item
                            label="Title"
                            name="title"
                            rules={[{ required: true, message: 'Please enter title' }]}
                        >
                            <Input placeholder="Enter title (e.g. Project Coordinator)" />
                        </Form.Item>
                        
                        <Form.Item
                            label="Last Name"
                            name="last_name"
                            rules={[{ required: true, message: 'Please enter last name' }]}
                        >
                            <Input placeholder="Enter last name" />
                        </Form.Item>
                        
                        <Form.Item
                            label="Middle Name"
                            name="middle_name"
                        >
                            <Input placeholder="Enter middle name (optional)" />
                        </Form.Item>
                        
                        <Form.Item
                            label="Phone"
                            name="phone"
                            rules={[{ required: false, message: 'Please enter phone number' }]}
                        >
                            <Input placeholder="Enter phone number" />
                        </Form.Item>
                        
                        <Form.Item
                            label="Email"
                            name="email"
                            rules={[
                                { required: true, message: 'Please enter email' },
                                { type: 'email', message: 'Please enter a valid email' }
                            ]}
                        >
                            <Input placeholder="Enter email address" />
                        </Form.Item>

                        <Form.Item 
                            name="roles" 
                            label="Role" 
                            rules={[{ required: true, message: 'Please select a role' }]}
                        >
                            <Select
                                mode="multiple"
                                placeholder="Select Role(s)"
                                onChange={handleRoleChange}
                            >
                                {roles.map((role) => (
                                    <Select.Option key={role.id} value={role.name}>
                                        {role.name}
                                    </Select.Option>
                                ))}
                            </Select>
                        </Form.Item>

                        {(showProjectDropdown || showProcuringEntityDropdown) && (
                            <Form.Item
                                name="project"
                                label="Project"
                                rules={[{ required: true, message: "Please select a project!" }]}
                            >
                                <Select
                                    placeholder="Select Project"
                                    mode={showProcuringEntityDropdown ? undefined : "multiple"}
                                    onChange={(value) => handleProjectChange(value)}
                                >
                                    {projects?.map((project, index) => (
                                        <Select.Option key={index} value={project.id}>
                                            {project.name}
                                        </Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        )}

                        {showProcuringEntityDropdown && (
                            <Form.Item
                                name="council_id"
                                label="Council"
                                rules={[{ required: true, message: "Please select a Council!" }]}
                            >
                                <Select
                                    placeholder="Select Council"
                                    showSearch
                                    optionFilterProp="children"
                                    disabled={!projects || projects.length === 0}
                                >
                                    {procuringEntities?.map((entity, index) => (
                                        <Select.Option key={index} value={entity.id}>
                                            {entity.name}
                                        </Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        )}

                        <div style={{ 
                            padding: '12px', 
                            backgroundColor: '#e6f7ff', 
                            border: '1px solid #91d5ff', 
                            borderRadius: '6px',
                            marginBottom: '16px'
                        }}>
                            <p style={{ margin: 0, color: '#0050b3' }}>
                                🎉 New users will receive an invitation email to set their password. No need to specify a password here!
                            </p>
                        </div>
                    </Form>

                    <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'center' }}>
                        {canCreateUser ? (
                            <Button 
                                type="primary" 
                                onClick={handleCreateUser}
                                disabled={loading}
                                loading={loading}
                                style={{ minWidth: '208px' }}
                            >
                                Create User & Send Invite
                            </Button>
                        ) : (
                            <div style={{ padding: '8px 16px', background: '#f5f5f5', borderRadius: '4px', color: '#666' }}>
                                You don't have permission to create users
                            </div>
                        )}
                    </div>
                </Spin>
            </Hide>
        </div>
    );
};

export default UserComponent;
